import React, { useState, useEffect } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    CircularProgress
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import TechStateMonthRows from './TechStateMonthRows';
const useStyles = makeStyles({
    table: {
        "& .MuiTableCell-root": {
            border: "1px solid rgba(224, 224, 224, 1)",
            align: 'center'
        }
    }
});


const TechStateMonthTable = ({ headerRows, plnTyps, data }) => {
    const classes = useStyles();
    const [tableWidth, setTableWidth] = useState(1000);

    useEffect(() => {
        if (headerRows.length > 0) {
            const rowsWidth = (headerRows.length * 520) + 1000;
            //console.log(rowsWidth, 'rowsWidth')
            setTableWidth(rowsWidth)
        }
    }, [headerRows])


    if (!headerRows || !plnTyps || !data) {
        return null;
    }


    return (
        <Paper sx={{ width: '78vw', overflow: 'hidden', my: 1 }}>
            <TableContainer sx={{ overflowX: 'auto', maxHeight: 'calc(100vh - 250px)' }} >
                <Table className={classes.table} sx={{ minWidth: tableWidth }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" rowSpan={2}>회사</TableCell>
                            <TableCell align="center" rowSpan={2}>본부</TableCell>
                            <TableCell align="center" rowSpan={2}>팀</TableCell>
                            <TableCell align="center" rowSpan={2}>사원</TableCell>
                            <TableCell align="center" rowSpan={2}>구분</TableCell>
                            <TableCell align="center" rowSpan={2}>개별실적</TableCell>
                            {headerRows.length > 0 && headerRows.map((header, index) => (
                                <TableCell align="center" key={index} colSpan={5}>{header.title}</TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            {headerRows.map((header, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <TableCell align="center">평일</TableCell>
                                        <TableCell align="center">주말</TableCell>
                                        <TableCell align="center">합계</TableCell>
                                        <TableCell align="center">160시간 초과</TableCell>
                                        <TableCell align="center">초과율</TableCell>
                                    </React.Fragment>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TechStateMonthRows headerRows={headerRows} plnTyps={plnTyps} data={data} />

                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default TechStateMonthTable